var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5866 4.38259L26.5621 8.21119L30.2498 6.09886C37.8886 1.80818 45.4615 11.7758 39.2714 17.9807L36.2423 21.0172L39.4031 23.9217C45.7907 29.8626 38.6788 40.1603 30.9083 36.1996L27.0889 34.2853L25.311 38.18C21.6891 46.1012 9.70417 42.5367 11.0212 33.8893L11.6797 29.6646L7.4652 29.1365C-1.22718 28.1464 -1.49059 15.6044 7.13595 14.2181L11.3505 13.558L10.4944 9.39938C8.78226 0.75201 20.6355 -3.40665 24.5866 4.38259Z",
    fill: "currentColor"
  })));
};
export default SvgTag;